import { getPortalScopesRequestState } from 'FormsUI/selectors/PortalScopes';
import { getPortalScopes } from 'FormsUI/api/PortalScopes';
const createAction = name => `@@portalScopes/${name}`;
export const REQUEST_PORTAL_SCOPES = createAction('REQUEST_PORTAL_SCOPES');
export const RECEIVE_PORTAL_SCOPES = createAction('RECEIVE_PORTAL_SCOPES');
export const FAIL_PORTAL_SCOPES = createAction('FAIL_PORTAL_SCOPES');
export const requestPortalScopes = () => ({
  type: REQUEST_PORTAL_SCOPES
});
export const receivePortalScopes = portalScopes => ({
  type: RECEIVE_PORTAL_SCOPES,
  portalScopes
});
export const failPortalScopes = () => ({
  type: FAIL_PORTAL_SCOPES
});
export const fetchPortalScopes = () => (dispatch, getState) => {
  const state = getState();
  if (!getPortalScopesRequestState(state).shouldBeRequested()) {
    return;
  }
  dispatch(requestPortalScopes());
  return getPortalScopes().then(response => {
    const {
      scopes
    } = response;
    dispatch(receivePortalScopes(scopes));
  }, () => {
    dispatch(failPortalScopes());
  });
};